import { useEffect, useLayoutEffect } from 'react';

/**
 * useIsomorphicLayoutEffect
 *
 * A hook that uses useLayoutEffect on the client and useEffect on the server.
 * This prevents the warning: "useLayoutEffect does nothing on the server"
 *
 * useLayoutEffect is used on the client to ensure synchronous updates before paint.
 * useEffect is used on the server since layout effects don't apply during SSR.
 */
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
